var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _vm.JobCard
            ? _c(
                "b-form",
                {
                  ref: "form",
                  staticClass: "repeater-form",
                  on: {
                    change: function ($event) {
                      return _vm.formChanged()
                    },
                  },
                },
                _vm._l(_vm.JobCard.bom, function (item, index) {
                  return _c(
                    "b-row",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      key: index,
                      ref: "row",
                      refInFor: true,
                      attrs: {
                        id: index.toString(),
                        title:
                          "Once a purchase order has been created you cannot modify any information except status!",
                      },
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "cost", placeholder: "", hidden: "" },
                            model: {
                              value: item.materialId,
                              callback: function ($$v) {
                                _vm.$set(item, "materialId", $$v)
                              },
                              expression: "item.materialId",
                            },
                          }),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Raw Material / Work In Progress",
                                "label-for": "Operation-name",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cost",
                                  placeholder: "",
                                  disabled: "",
                                },
                                model: {
                                  value: item.rawMaterial,
                                  callback: function ($$v) {
                                    _vm.$set(item, "rawMaterial", $$v)
                                  },
                                  expression: "item.rawMaterial",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    new Date(item.createdOn).toLocaleDateString(
                                      "fr-FR"
                                    )
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "1" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: { label: "Status", "label-for": "Status" },
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.BOMStatusList },
                                on: {
                                  change: function ($event) {
                                    return _vm.callChangeStatus(item)
                                  },
                                },
                                model: {
                                  value: item.status,
                                  callback: function ($$v) {
                                    _vm.$set(item, "status", $$v)
                                  },
                                  expression: "item.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Warehouse",
                                "label-for": "Warehouse",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.optionsWarehouse },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateQtyAtHand(item)
                                  },
                                },
                                model: {
                                  value: item.wareHouseId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "wareHouseId", $$v)
                                  },
                                  expression: "item.wareHouseId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "1" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "UOM", "label-for": "cost" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cost",
                                  placeholder: "",
                                  disabled: "",
                                },
                                model: {
                                  value: item.uom,
                                  callback: function ($$v) {
                                    _vm.$set(item, "uom", $$v)
                                  },
                                  expression: "item.uom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "1" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Qty at hand",
                                "label-for": "materialQtyAtHand",
                              },
                            },
                            [
                              _c("b-form-input", {
                                ref: "qtyAtHandInput",
                                refInFor: true,
                                attrs: {
                                  id: "materialQtyAtHand",
                                  name: "materialQtyAtHand",
                                  readonly: "",
                                },
                                model: {
                                  value: item.physicalinventory,
                                  callback: function ($$v) {
                                    _vm.$set(item, "physicalinventory", $$v)
                                  },
                                  expression: "item.physicalinventory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "1" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Qty Required",
                                "label-for": "cost",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cost",
                                  type: "number",
                                  placeholder: "",
                                  value: item.quantity,
                                  readonly: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.itemChanged(item, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "1", md: "1" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Total Cost",
                                "label-for": "price",
                              },
                            },
                            [
                              _vm.HasPermission(
                                _vm.PermissionList.Production_Finance
                              )
                                ? _c("b-form-input", {
                                    attrs: {
                                      id: "pzrice",
                                      value: "32$",
                                      disabled: "",
                                    },
                                    model: {
                                      value: item.totalCost,
                                      callback: function ($$v) {
                                        _vm.$set(item, "totalCost", $$v)
                                      },
                                      expression: "item.totalCost",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mr-2", attrs: { lg: "1", md: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-0 mt-md-2 mr-6",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDocumentBtn(item.materialId)
                                },
                              },
                            },
                            [_c("span", [_vm._v("View Document")])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "1", md: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(234, 84, 85, 0.15)",
                                  expression: "'rgba(234, 84, 85, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mt-2 mt-md-2 mr-3",
                              attrs: { variant: "outline-danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(index, item.id)
                                },
                              },
                            },
                            [_c("feather-icon", { attrs: { icon: "XIcon" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-0 d-flex align-items-center",
                          attrs: { md: "1" },
                        },
                        [
                          _c("b-form-checkbox", {
                            staticClass: "mb-0",
                            attrs: { value: item.itemId },
                            on: {
                              change: function ($event) {
                                return _vm.AddBOMPO(item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-view-raw-material-document",
          attrs: {
            id: "modal-view-raw-material-document",
            "ok-only": "",
            "ok-title": "View",
            centered: "",
            size: "lg",
            title: "View Raw Material Documents",
            "hide-footer": true,
          },
        },
        [
          _c("DocumentUpload", {
            attrs: { documentDetails: _vm.documentDetails, viewOnly: true },
            on: { downloadFile: _vm.downloadFile },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }